/**
 * Hides the loading spinner placed in front of the Appstle subscription
 * widget once the widget finishes rendering its own content, so the delay
 * QA flagged reads as an intentional loading state instead of a blank gap.
 * Falls back to a max wait in case the widget never triggers an observable
 * DOM change (e.g. it renders inside a closed shadow root).
 */
(function () {
  var FALLBACK_MS = 6000;
  var SETTLE_MS = 400;

  function revealWidget(wrapper) {
    var spinner = wrapper.querySelector('.appstle-widget-spinner');
    if (spinner) spinner.classList.add('hidden');
    wrapper.classList.remove('appstle-widget-wrapper--loading');
  }

  function watchWidget(wrapper) {
    var revealed = false;
    var settleTimer;

    var fallbackTimer = setTimeout(function () {
      finish();
    }, FALLBACK_MS);

    var observer = new MutationObserver(function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(finish, SETTLE_MS);
    });

    function finish() {
      if (revealed) return;
      revealed = true;
      clearTimeout(fallbackTimer);
      clearTimeout(settleTimer);
      observer.disconnect();
      revealWidget(wrapper);
    }

    observer.observe(wrapper, { childList: true, subtree: true, characterData: true, attributes: true });
  }

  function init(root) {
    root.querySelectorAll('[data-appstle-widget-wrapper]').forEach(watchWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Theme editor re-renders a section's markup on every settings change,
  // dropping in a fresh (unwatched) wrapper that would otherwise be stuck
  // showing the spinner forever.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
